<section class="page-wrap animated fadeIn">

  <header class="pattern-header">
    FAQ
  </header>

  <div class="d-flex justify-content-center align-items-center mb-5">
    <div class="landing-container faqs">

      <section class="faqs__info" [class.faqs__info--border]="!isMobile()">

        <div class="menu">
          @for (item of categories(); track $index) {
          <span class="h6-regular item" [class.fw-bold]="item.active" (click)="categoryChanged(item)">
            {{item.category}}
          </span>
          }
        </div>

        @if (!isMobile()) {
        <ng-container *ngTemplateOutlet="contactUs;"></ng-container>
        }

      </section>

      <section class="faqs__questions">

        @if(isMobile()) {
        <hr>
        }

        <h3 class="h3-bold text-primary">
          {{questions()?.category}}
        </h3>

        <div ngbAccordion [closeOthers]="true">
          @for (item of questions()?.questions; track item) {
          @if(item.isHeaderSection) {
          <div class="h5 fw-semibold text-black-50">{{item.question}}</div>
          <div class="h6-regular" [innerHTML]="item.answer"></div>
          } @else {
          <div ngbAccordionItem [collapsed]="true">
            <h2 ngbAccordionHeader>
              <button class="h6-bold fw-semibold" type="button" ngbAccordionButton>
                {{item.question}}
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <div class="h6-regular" [innerHTML]="item.answer">
                </div>
              </div>
            </div>
          </div>
          }
          }
        </div>

      </section>

      @if (isMobile()) {
      <hr>
      <ng-container *ngTemplateOutlet="contactUs;"></ng-container>
      }

    </div>
  </div>

</section>

<ng-template #contactUs>
  <div class="d-flex flex-column gap-4">

    <div>
      <span class="h6-bold">
        Who do I contact with a question?
      </span>
      <p class="h7-regular m-0">
        Your satisfaction is our top priority. Please call us at:
      </p>
    </div>

    <div class="contact-card">

      <span class="material-symbols-outlined text-primary">
        call
      </span>

      <div class="d-flex flex-column g-2">
        <span class="h6-bold">
          Phone
        </span>
        <span class="h6-regular">
          (770) 655-1503
        </span>
      </div>

    </div>

    <div class="contact-card">

      <span class="material-symbols-outlined text-primary">
        mail
      </span>

      <div class="d-flex flex-column g-2">
        <span class="h6-bold">
          Email
        </span>
        <span class="h6-regular">
          {{'info@carltonfarm.com'}}
        </span>
      </div>

    </div>

    <button class="btn btn-primary" type="button" [routerLink]="['/pages/contact-us']">
      Contact us
    </button>

  </div>
</ng-template>